module.exports = __webpack_public_path__ + "static/media/not-rate.3fbdb9cf.svg";